import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetRequest =
  ({ callback, status, page, categorize_by = "none", rowsPerPage, sort }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.requests.get;
      const body = {
        status: status,
      };

      body.page = page;
      // "oldest" lists the longest-waiting first, like the case inbox.
      if (sort) body.sort = sort;
      if (rowsPerPage) {
        body.rowsPerPage = rowsPerPage;
      }

      if (categorize_by !== "none") {
        // "year" / "month" / "week"
        body.categorize_by = categorize_by;
      }

      const response = await PostFunction({
        data: body,
        Route: link,
        showalert: false,
        // The list says a failed load itself, with Try again.
        showerror: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const SearchRequests =
  ({ callback, search }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.requests.search;
      const data = {
        search,
      };

      const response = await PostFunction({
        data,
        Route: link,
        showalert: false,
        // The list says a failed load itself, with Try again.
        showerror: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

const post = (Route, data, dispatch) => PostFunction({ Route, data, showalert: false, showerror: false, isMultipart: false, dispatch });

// request/search matches a name, an email or a request number, oldest first,
// and each row carries client_email. An older API matched names only; then a
// number opens that request (request/get-one) and an email finds the
// customer (clients/search) and their requests by name, kept to them.
// Every answer is a list of rows shaped like request/search's.
export async function findRequests(search, dispatch) {
  const text = search.trim();
  const number = /^#?(\d+)$/.exec(text);
  const rows = (await post(UrlApi.requests.search, { search: number ? number[1] : text, sort: "oldest" }, dispatch))?.data || [];
  if (rows.length && rows.every((row) => "client_email" in row)) return rows;
  if (!number && !text.includes("@")) return rows;
  if (number) {
    try {
      const response = await post(UrlApi.requests.get_one, { id: Number(number[1]) }, dispatch);
      if (!response?.data) return [];
      const { request_answers, request_documents, ...row } = response.data;
      return [row];
    } catch {
      return [];
    }
  }
  if (text.includes("@")) {
    const clients = (await post(UrlApi.clients.search, { search: text }, dispatch))?.data || [];
    const ids = new Set(clients.map((c) => c.id));
    const names = [...new Set(clients.map((c) => (c.first_name || c.last_name || "").trim()).filter(Boolean))].slice(0, 5);
    const lists = await Promise.all(names.map((name) => post(UrlApi.requests.search, { search: name }, dispatch).then((r) => r?.data || [])));
    const seen = new Set();
    return lists.flat().filter((row) => ids.has(row.client_id) && !seen.has(row.id) && seen.add(row.id));
  }
  return rows;
}
